const { server_ip }= require('../config');

async function validToken(token){
    try {
        const response= await fetch(`${server_ip}/api/participants/valid/${token}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

async function loginWithPassword(username,password){
    try {
        const response= await fetch(`${server_ip}/api/participants/new`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username,
                password
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

async function joinGame(gameId,participantId){
    try {
        const response= await fetch(`${server_ip}/api/games/join`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                gameId,participantId
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}
async function forceJoinGame(gameId,participantId){
    try {
        const response= await fetch(`${server_ip}/api/games/forcejoin`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                gameId,participantId
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

async function updateParticipation(gameId,participantId,participationId,turn,data){
    try {
        const response= await fetch(`${server_ip}/api/games/update`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                gameId,participantId,participationId,turn,data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

async function fetchGameList(){
    try {
        const response= await fetch(`${server_ip}/api/games`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}
async function gameStatus(gameId){
    try {
        const response= await fetch(`${server_ip}/api/games/status/${gameId}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}


export {
    validToken,
    loginWithPassword,
    fetchGameList,
    joinGame,
    gameStatus,
    updateParticipation,
    forceJoinGame
}